import { Component, OnInit } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { InvalidValueMode, ListOption } from '../../core/editable-fields/dropdown/dropdown.component';
import { LayoutMode, RadioOption } from '../../core/editable-fields/radio-list/radio-list.component';
import { FormatSpecifier, InputMode } from '../../core/editable-fields/text-input/text-input.component';
import { AuthenticationService } from '../../core/services/authentication.service';
import { TestService } from './test.service';
import { PeopleService } from '../../services/people.service';


@Component({
    selector: 'app-test',
    templateUrl: './test.component.html',
    styleUrls: ['./test.component.scss'],
    standalone: false
})
export class TestComponent implements OnInit{
  public now: Date = new Date();
  
  public formObject: any = {
    errors$: new BehaviorSubject({}),
    warnings$: new BehaviorSubject({}),
    editableFields$: new BehaviorSubject(new Set<string>()),
    allIsEditable: true,  //  Not in the UI but can be used to quickly test the editable view when working locally
    allLabelCols: 4,
    useOptionalSizes: false,
    allLabelColsSm: null,
    allLabelColsMd: null,
    allLabelColsLg: null,
    allLabelColsXl: null,
    allLabelColsXxl: null,
    arrayBuilder: [],
    arrayBuilder2: [],
    booleanSlider: false,
    date: '',
    dateTime: '',
    dropdown: '',
    dropdownMulti: [],
    fileUpload:null,
    monthYear: '',
    richTextInput: '',
    textInput: '',
    textInputDollarsCents: '',
    textInputDollarsOnly: '',
    textInputCostCode: '',
    textAreaInput: '',
    textInputTypeahead: '',
    textInputTypeahead2: '',
    textInputTypeahead3: '',
    numberInput: '',
    radio: '',
    time: '',
  }

  //  Elements used for the dropdown lists
  //  Expose the type locally so we can use it in the HTML
  public get invalidValueMode(): typeof InvalidValueMode {
    return InvalidValueMode;
  }

  public get inputMode(): typeof InputMode {
    return InputMode;
  }

  public get layoutMode(): typeof LayoutMode {
    return LayoutMode;
  }
  public get formatter(): typeof FormatSpecifier {
    return FormatSpecifier;
  }

  public emitter(event) {
    console.log("This should only emit when an option is selected from the typeahead dropdown", event);
  }

  private fruits = ["Apple", "Banana", "Coconut", "Durian", "Eggplant", "Blueberry", "Raspberry", "Strawberry" ];
  public dropdownList$: Observable<ListOption[]> = of(this.fruits.map(f => new ListOption(f, f)));

  private cakes = [new RadioOption("chocolate", "Chocolate Cake", "Cake made with chocolate"), new RadioOption("sponge", "Sponge Cake", "Cake made with sponge")];
  
  public radioOptionList$: Observable<RadioOption[]> = of(this.cakes);

  // A typeahead list lookup observable based on a simple list of string. 
  public simpleTypeAheadList$(query: string): Observable<any[]> {
    return of(
      this.fruits
        .filter(item => item.toLowerCase().includes(query?.toLowerCase()))
        .map(str => ({ name: str }) )
    )
  }

  // A typeahead list lookup observable based on a typeahead object. 
  public objectTypeAheadList$(query: string): Observable<any[]> {
    let i = 0;

    return of(
      this.fruits
        .filter(item => item.toLowerCase().includes(query?.toLowerCase()))
        .map(str => ({ name: str , value: i++}))
    )
  }
  
  //  Let in for local testing when we receive a list in Key/Value format
  private fruits2 = [
    { Key: 'Apple', Value: 'A' },
    { Key: 'Banana', Value: 'B' },
    { Key: 'Coconut', Value: 'C' },
    { Key: 'Durian', Value: 'D' },
    { Key: 'Eggplant', Value: 'E' }
  ];
  public dropdownList2$: Observable<ListOption[]> = of(this.fruits2.map(f => new ListOption(f.Key, f.Value)));

   public personLookup$: (query: string) => Observable<{ name }[]>;

  constructor(
      public testService: TestService,
      public auth: AuthenticationService,
      public peopleService: PeopleService,
  ) {}

    public ngOnInit(): void {
    this.formObject.clean = () => this.testService.clean(this.formObject);
    this.formObject.validate = () => this.testService.validate(this.formObject);
    this.formObject.onChange = () => {
      this.setLabelSizes(this.formObject.useOptionalSizes);
      this.testService.onChange(this.formObject);
    }

    this.formObject.validate();
  }

  private setLabelSizes(useOptionalSizes: boolean) {
    if (!useOptionalSizes) {
      this.formObject.allLabelColsSm = this.formObject.allLabelCols;
      this.formObject.allLabelColsMd = this.formObject.allLabelCols;
      this.formObject.allLabelColsLg = this.formObject.allLabelCols;
      this.formObject.allLabelColsXl = this.formObject.allLabelCols;
      this.formObject.allLabelColsXxl = this.formObject.allLabelCols;
    }
    else {
      //  Sizes the optional label cols if they get changed to a non-number or are not set
      if (Number.isNaN(this.formObject.allLabelColsSm) || (this.formObject.allLabelColsSm == null))
        this.formObject.allLabelColsSm = this.formObject.allLabelCols;

      if (Number.isNaN(this.formObject.allLabelColsMd) || (this.formObject.allLabelColsMd == null))
        this.formObject.allLabelColsMd = this.formObject.allLabelColsSm;

      if (Number.isNaN(this.formObject.allLabelColsLg) || (this.formObject.allLabelColsLg == null))
        this.formObject.allLabelColsLg = this.formObject.allLabelColsMd;

      if (Number.isNaN(this.formObject.allLabelColsXl) || (this.formObject.allLabelColsXl == null))
        this.formObject.allLabelColsXl = this.formObject.allLabelColsLg;

      if (Number.isNaN(this.formObject.allLabelColsXxl) || (this.formObject.allLabelColsXxl == null))
        this.formObject.allLabelColsXxl = this.formObject.allLabelColsXl;
    }
  }
}


